// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3gCqI","inputWrap":"styles_inputWrap__3G09-","input":"styles_input__3EoZr"};